<template>
<div>
  <basic-container>
    <div class="page-container">
      <div class="tabs">
        <el-tabs :value="activiedTab" type="card" @tab-click="handleTabClick">
          <el-tab-pane name="1" label="线上数据"></el-tab-pane>
          <el-tab-pane name="0" label="本地数据"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="table table-wrap" v-loading="listLoading" element-loading-text="加载中">
        <div class="local-table" v-if="isLocal">
          <avue-crud :option="avueOption"
            :table-loading="loading"
            @selection-change="handleSelect"
            :data="tableData"
            ref="crud"
            :page="page"
            @current-change="currentChange"
            @refresh-change="refreshChange"
            @on-load="onLoad">
            <template slot="menuLeft">
              <div class="query-form-wrap">
                <el-form :inline="true" :model="form" :size="formSize">
                  <el-form-item>
                    <el-select @focus="handleSearchChannel" filterable clearable v-model="form.distributeProductId" placeholder="请选择企业会员商品">
                      <el-option
                        v-for="item in productLists"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select clearable v-model="form.status" placeholder="状态">
                      <el-option
                        v-for="item in partnerStatusOptions"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-show="isLocal">
                    <el-select clearable v-model="form.reviewStatus" placeholder="审核状态">
                      <el-option
                        v-for="item in approveStatusOptions"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button v-auth="'ACTIVITY_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
                    <el-button v-auth="'ACTIVITY_ADD'" icon="el-icon-plus" plain type="primary" @click="handleOpen">新增</el-button>
                    <el-button v-auth="'ACTIVITY_DELETE'" icon="el-icon-delete" :loading="delLoading" plain type="danger" @click="handleDelete">删除</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </template>
            <template slot-scope="scope" slot="menu">
              <el-button v-auth="'ACTIVITY_VIEW_LOG'" size="mini" type="text" @click="handleCheckLogs(scope.row)">查看日志</el-button>
              <el-button v-auth="'ACTIVITY_EDIT'" v-show="scope.row.reviewStatus != 1" size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-auth="'ACTIVITY_APPROVE'" size="mini" v-show="scope.row.reviewStatus == 1" type="text" :loading="approveLoading" @click="handleApprove(scope.row)">审核</el-button>
              <el-button v-auth="'ACTIVITY_REVOCATION'" size="mini" v-show="scope.row.reviewStatus == 1" type="text" :loading="approveLoading" @click="handleRevocation(scope.row)">撤销审核</el-button>
              <el-button v-auth="'ACTIVITY_APPROVE_SUBMIT'" size="mini" v-show="scope.row.reviewStatus == 0" type="text" :loading="approveLoading" @click="handleApproveRequest(scope.row)">提交审核</el-button>
            </template>
          </avue-crud>
        </div>
        <div class="online-table" v-else>
          <avue-crud :option="onLineOption"
            :table-loading="loading"
            :data="tableData"
            ref="crud2"
            :page="page"
            @current-change="currentChange"
            @on-load="getList">
            <template slot="menuLeft">
              <div class="query-form-wrap">
                <el-form :inline="true" :model="form" :size="formSize">
                  <el-form-item>
                    <el-select filterable clearable v-model="form.distributeProductId" placeholder="请选择企业会员商品">
                      <el-option
                        v-for="item in productLists"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select clearable v-model="form.status" placeholder="状态">
                      <el-option
                        v-for="item in partnerStatusOptions"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button v-auth="'ACTIVITY_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </template>
          </avue-crud>
        </div>
      </div>
    </div>
    <add-sales-scheme-popups :row="currentRow" :visible.sync="showAdd" :is-edit.sync="isEdit" :products="productLists" @onSubmit="handleSubmit"></add-sales-scheme-popups>
    <approve-popups :loading="approveLoading" :visible.sync="showApprove" :data="currentRow" @approve="submitApprove"></approve-popups>
    <approve-log-popups :logs="logs" :visible.sync="showLog"></approve-log-popups>
  </basic-container>
</div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import AddSalesSchemePopups from './addSalesScheme';
import ApprovePopups from './approvePopups';
import ApproveLogPopups from '@/components/ApproveLogPopups';
import {
  getSaleSchemeList
} from '@/api/partner';
import { merge } from '@/util/common';
  export default {
    name: 'PartnerSalesPage',
    data() {
      const checkContent = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入审核意见'));
        } else {
          callback();
        }
      };
      return {
        formSize: 'small',
        showLog: false,
        showAdd: false,
        isEdit: false,
        currentRow: {},
        selectedRows: [],
        page: {
          pageSize: 10,
          currentPage:1,
          total: 100
        },
        tableData: [],
        avueOption: {
          addBtn: false,
          viewBtn: false,
          editBtn: false,
          delBtn: false,
          refreshBtn: false,
          height: 'auto',
          calcHeight: 200,
          tip: false,
          columnBtn:false,
          searchShow: true,
          searchMenuSpan: 2,
          border: true,
          index: false,
          selection: true,
          column: [{
            label: '企业会员商品',
            prop: 'distributeProductName',
            width: 200,
            align: 'left',
          }, {
            label: '绑定邀请码购买赠送商品',
            minWidth: 200,
            prop: 'rewardProductName',
            align: 'left',
          }, {
            label: '首次购买分成金额',
            prop: 'proportionFirst',
            width: 120,
            align: 'center',
          }, {
            label: '二次购买分成金额',
            prop: 'proportionSecond',
            width: 120,
            align: 'center',
          }, {
            label: '三次购买分成金额',
            prop: 'proportionThird',
            width: 120,
            align: 'center',
          }, {
            label: '状态',
            prop: 'status',
            formatter: this.formatStatus,
            width: 80,
            align: 'center'
          }, {
            label: '审核状态',
            prop: 'reviewStatus',
            formatter: this.formatApproveStatus,
            width: 80,
            align: 'center'
          }, {
            label: '备注',
            prop: 'remark',
            width: 180,
            align: 'left'
          }, {
            label: '更新时间',
            prop: 'updateTime',
            width: 200,
            align: 'center'
          },
          {
            label: '线上ID',
            prop: 'originalId',
            width: 200,
            align: 'center'
          }]
        },
        onLineOption: {
          menu: false,
          addBtn: false,
          viewBtn: false,
          editBtn: false,
          delBtn: false,
          height: 'auto',
          calcHeight: 200,
          refreshBtn: false,
          columnBtn:false,
          tip: false,
          searchShow: true,
          searchMenuSpan: 2,
          border: true,
          index: false,
          selection: false,
          column: [{
            label: '企业会员商品',
            prop: 'distributeProductName',
            width: 200,
            align: 'left',
          }, {
            label: '绑定邀请码购买赠送商品',
            prop: 'rewardProductName',
            minWidth: 200,
            align: 'left',
          }, {
            label: '首次购买分成比例',
            prop: 'proportionFirst',
            width: 120,
            align: 'center',
          }, {
            label: '二次购买分成比例',
            prop: 'proportionSecond',
            width: 120,
            align: 'center',
          }, {
            label: '三次购买分成比例',
            prop: 'proportionThird',
            width: 120,
            align: 'center',
          }, {
            label: '状态',
            prop: 'status',
            formatter: this.formatStatus,
            width: 80,
            align: 'center'
          }, {
            label: '提交人',
            prop: 'createUser',
            width: 180,
            align: 'center'
          }, {
            label: '审核意见',
            prop: 'remark',
            width: 200,
            align: 'center'
          },
          {
            label: 'ID',
            prop: 'id',
            width: 200,
            align: 'center'
          }]
        },
        form: {
          // current: 1, // 分页页码
          size: 10, // 分页大小
          isUsed: '1', // 1: 线上， 2： 线下
          distributeProductId: '', // 商品id
          name: '', // name
          reviewStatus: '', // 审核状态
          status: '1' // 售价状态 
        },
        showApprove: false,
        approveLoading: false,
        listLoading: false,
        submitLoading: false,
        delLoading: false,
        selectedAll: false,
        channel: 1,
        formRules: {
          content: [
            { validator: checkContent, message: '请输入审核意见', trigger: 'blur' }
          ]
        },
        approveForm: {
          content: '',
          bizRefrenceId: '',
          status: '', // 0草稿 1提交审核 2审核通过 3审核拒绝 4撤销审核
        }
      }
    },
    components: {
      AddSalesSchemePopups,
      ApproveLogPopups,
      ApprovePopups
    },
    computed: {
      ...mapState('partner', ['total', 'activityList', 'salesSchemeList', 'activiedTab', 'memberProdList']),
      ...mapGetters('app', ['logs']),
      ...mapGetters('partner', ['approveStatusOptions', 'partnerStatusOptions']),
      productLists() {
        return this.memberProdList.map(item => {
          item.name = `[${item.productCode}]${item.name}`
          return item
        })
      },
      isLocal() {
        return this.activiedTab === '0';
      }
    },
    methods: {
      ...mapActions('partner', [
        'deleteSaleScheme',
        'getSalesSchemes',
        'addSaleScheme',
        'changeTab',
        'getProductList',
        'approveRequire',
        'handleApporveFlow',
        'getDicts'
      ]),
      ...mapActions('app', ['getLogs']),
      handleTabClick({ name }) {
        this.form.isUsed = name
        this.changeTab(name)
        this.getList()
      },
      handleSearch() {
        if(this.activiedTab == 0){
          console.log(111)
        } else {
          this.form.reviewStatus = ''
        }
        this.getList();
      },
      // 获取日志
      handleCheckLogs(row) {
        this.showLog = true;
        this.getLogs({
          bizCode: 31,
          bizRefrenceId: row.id
        })
      },
      // 审核内容
      handleApprove(row) {
        row.statusName = this.formatStatus(row);
        this.currentRow = row;
        this.showApprove = true;
      },
      // 审核申请
      handleApproveRequest(row) {
        this.approveLoading = true;
        this.approveRequire({
          bizRefrenceId: row.id,
          status: 1 //提交审核
        }).then(isSuccess => {
          if (isSuccess) {
            this.getList();
          }
        }).finally(() => {
          this.approveLoading = false;
        })
      },
      // 撤销审核
      handleRevocation(row) {
        const query = merge({}, {
          bizRefrenceId: row.id,
          status: 4
        });
        this.submitApprove(query);
      },
      // 提交审核数据
      submitApprove(data) {
        this.approveLoading = true;
        this.handleApporveFlow(data).then(success => {
          if (success) {
            this.showApprove = false;
            this.getList();
          }
        }).finally(() => {
          this.approveLoading = false;
        })
      },
      currentChange(currentPage) {
        console.log(this.page.currentPage);
        this.page.currentPage = currentPage;
        this.getList()
      },
      getList() {
        const query = merge({}, this.form, {
          isUsed: this.activiedTab,
          current: this.page.currentPage,
          size: this.page.pageSize
        });
        this.listLoading = true;
        getSaleSchemeList(query)
        .then(({data: res}) => {
          if (res.code === 200) {
            const data = res.data || {};
            this.tableData = data.records;
            this.page.total = data.total;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
      },
      // 选择数据
      handleSelect(selection) {
        this.selectedRows = selection;
      },
      // 编辑数据
      handleEdit(row) {
        // 待审核 数据不给修改
        if (row.reviewStatus == 1) {
          this.$alert('待审核状态不可修改，请撤销审核后再修改', '提示', {
            confirmButtonText: '知道了',
          });
          return false;
        }
        this.currentRow = row;
        this.isEdit = true;
        this.handleOpen();
      },
      // 删除数据
      handleDelete() {
        // 如果选中的记录已经审核通过，则提示“该记录已审核通过，不能删除！”
        if (this.selectedRows.length > 0) {
          const hasApproved = this.selectedRows.some(item => item.reviewStatus == 2);
          if (hasApproved) {
            this.$alert('记录中包含已审核通过的数据，不能删除！', '提示', {
              confirmButtonText: '知道了',
            });
            return false;
          }
          this.$confirm('确定要删除选择的记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const ids = this.selectedRows.map(item => item.id).join(',');
            this.delLoading = true;
            this.deleteSaleScheme({ ids }).then(isSuccess => {
              if (isSuccess) {
                this.selectedRows = [];
                this.getList();
              }
            }).finally(() => {
              this.delLoading = false;
            });
          })
        } else {
          this.$alert('请选择要删除的记录', '提示', {
            confirmButtonText: '知道了',
          });
        }
      },
      // 打开编辑窗口
      handleOpen() {
        this.showAdd = true;
      },
      // 保存数据
      handleSubmit(data) {
        this.addSaleScheme(data).then(isSuccess => {
          if (isSuccess) {
            this.showAdd = false;
            this.isEdit = false;
            this.$message.success('数据插入成功');
            this.getList();
          }
        })
      },
      // 取消编辑数据
      handleCancel() {
        this.isEdit = false;
        this.currentRow = {};
        this.selectedRows = [];
        this.showAdd = false;
      },
      // 格式状态
      formatStatus({ status }) {
        for(let item of this.partnerStatusOptions) {
          if (item.dictKey == status) {
            return item.dictValue
          }
        }
      },
      formatApproveStatus({ reviewStatus }) {
        for(let item of this.approveStatusOptions) {
          if (item.dictKey == reviewStatus) {
            return item.dictValue
          }
        }
      },
      formatSms({ isSmsNotice }) {
        for(let item of this.SMSStatus) {
          if (item.dictKey == isSmsNotice) {
            return item.dictValue
          }
        }
      }
    },
    created() {
      this.getProductList();
      this.getDicts('PARTNER_STATUS');
      this.getDicts('APPROVE_STATUS');
      this.getList();
    }
  }
</script>
<style lang="scss">
.el-tag + .el-tag {
  margin: 3px;
}
  .page-container {
    .tabs {
      margin-bottom: 10px;
    }
    .el-tabs--border-card {
      border-bottom: transparent;
      box-shadow: none;
    }
    .el-tabs--border-card>.el-tabs__content {
      padding: 0;
    }
  }
  .table-pagination {
    margin-top: 20px;
    text-align: right;
  }
  .approve-dialog__wrap {
    .activity-content {
      margin: 0;
      &.channel {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .el-form-item__label {
      font-weight: 900;
      color: #000000;
    }
    .el-form-item {
      margin-bottom: 5px;
    }
  }
</style>
